import { Icon } from '@platform/ui';
import type { IPersonLookupViewProps } from './IPersonLookupViewProps';

/**
 * Особа в режимі перегляду (прототип v4: комбобокс людей у формі для перегляду [data-ro] лишається рамкою --line2 на --surface, сіре —
 * лише поле введення між аватаром і ×; × і шеврон видно): та сама розмітка, що й у комбобокса, але лише для читання — × і шеврон
 * неактивні, список не відкривається.
 */
export function PersonLookupView({ id, label, text, initials, placeholder }: IPersonLookupViewProps) {
  return (
    <div className="lk fc-lkview">
      {text && initials && <span className="lk__avatar" aria-hidden>{initials}</span>}
      <input id={id} className="lk__input" role="combobox" aria-label={label} aria-expanded={false} aria-readonly readOnly value={text}
        placeholder={placeholder} title={text || undefined} />
      {text && <span className="lk__clear fc-lkview__x" aria-hidden>×</span>}
      <Icon name="chevron-down" size={14} strokeWidth={2} className="lk__chev" />
    </div>
  );
}
